// test1736
(1736 && 0);
